// @flow
import * as React from "react"
import { hot } from "react-hot-loader"
import { Marquee } from "../../components/Marquee"
import { Link } from "react-static"
import { tRouteProps, tHomeContent, tSiteProps } from "../../types"
import { Container } from "../../components/StyledComponents"
import { css } from "emotion/macro"
import { mq, color } from "../../styles/variables"
import { FlexibleContent } from "../../components/FlexibleContent"
import Slider from "react-slick"
import { PageMeta } from "../../components/PageMeta"

type tHome = {
  home_content: tHomeContent,
  flexible_content: Array<{}>
}

function Home(props: tHome & tRouteProps & tSiteProps) {
  return (
    <div>
      <PageMeta
        title="Center For Spiritual Living"
        description={props.home_content.services.copy}
        image={props.brand.logo}
      />
      <div
        className={css`
          overflow: hidden;
        `}
      >
        <Slider
          {...{
            dots: false,
            infinate: true,
            speed: 1000,
            slidesToScroll: 1,
            slidesToShow: 1,
            autoplay: true,
            fade: true
          }}
        >
          {props.home_content.marquee.map((slide) => (
            <Marquee key={slide.title} image={slide.image} className="">
              <Container
                className={css`
                  min-height: 382px;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  padding: 45px 0;

                  h1 {
                    color: ${slide.color};
                    font-size: 84px;
                  }
                `}
              >
                <h1 className="text-center">{slide.title}</h1>
              </Container>
            </Marquee>
          ))}
        </Slider>
      </div>
      <div
        className={css`
          text-align: center;
          font-size: 20px;
          font-weight: 800;
          color: ${color.rgb.white[0]};
          padding-top: 20px;
          padding-bottom: 20px;
          /* Permalink - use to edit and share this gradient: http://colorzilla.com/gradient-editor/#6c4f6e+0,ed9150+100 */
          background: #6c4f6e; /* Old browsers */
          background: -moz-linear-gradient(
            left,
            #6c4f6e 0%,
            #ed9150 100%
          ); /* FF3.6-15 */
          background: -webkit-linear-gradient(
            left,
            #6c4f6e 0%,
            #ed9150 100%
          ); /* Chrome10-25,Safari5.1-6 */
          background: linear-gradient(
            to right,
            #6c4f6e 0%,
            #ed9150 100%
          ); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
          filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#6c4f6e', endColorstr='#ed9150',GradientType=1 ); /* IE6-9 */

          .btn {
            margin-left: 30px;
          }
        `}
      >
        <Container>
          <span className="copy">{props.home_content.services.copy}</span>
          <span>
            {props.home_content.services.buttons.map((button) => (
              <Link
                className="btn btn-clear"
                key={button.label + button.url}
                to={button.url}
              >
                {button.label}
              </Link>
            ))}
          </span>
        </Container>
      </div>
      <Container>
        {props.flexible_content && (
          <Container>
            <FlexibleContent
              items={props.flexible_content}
              className={css`
                .btn {
                  margin-bottom: 30px;
                }

                ${mq.md(css`
                  .btn {
                    margin-bottom: 0;
                  }
                `)};
              `}
            />
          </Container>
        )}
      </Container>
    </div>
  )
}

export default hot(module)(Home)



// WEBPACK FOOTER //
// /opt/build/repo/src/screens/Page/Home.js